import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_ADMINS = "fetchAdminMessages";
export const STORE_ADMIN_TRANSACTION = "storeAdminMessages";

// mutation types
export const SET_ADMIN_MESSAGES = "setAdminMessages";
export const SET_ADMIN_MESSAGES_PAGINATION = "setAdminMessagesPagination";

const state = {
  adminMessages: [],
  adminMessagesPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  adminMessages(state) {
    return state.adminMessages;
  },
  adminMessagesPagination(state) {
    return state.adminMessagesPagination;
  }
};

const actions = {
  [FETCH_ADMIN_ADMINS](context) {
    let params = {
      page: context.state.adminMessagesPagination.currentPage
    };
    return new Promise((resolve, reject) => {
      ApiService.query("admin/messages", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_MESSAGES, data.data);
          context.commit(SET_ADMIN_MESSAGES_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ADMIN_MESSAGES](state, data) {
    state.adminMessages = data;
  },
  [SET_ADMIN_MESSAGES_PAGINATION](state, data) {
    state.adminMessagesPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
